// extracted by mini-css-extract-plugin
export default {"card":"z6-z"};